import React from 'react';
import PropTypes from 'prop-types';
import { ButtonToolbar, Table as BootstrapTable } from 'react-bootstrap';
import Button from '../../../../../../modules/react/components/stateless/Button';
import TimeAgo from '../TimeAgo';

function renderRow(site) {
  const {
    companyId, dateAdded, internalUrl, company: { corporateUrl, companySettingsUrl, name },
  } = site;
  return (
    <tr key={companyId}>
      <td>
        <a href={internalUrl} target="_blank" rel="noopener noreferrer">
          {name}
        </a>
      </td>
      <td>
        <TimeAgo date={dateAdded} />
      </td>
      <td>
        <ButtonToolbar>
          <Button
            variant="success"
            bsSize="xsmall"
            href={`${corporateUrl}/facilities`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Unified Platform
          </Button>
          {
            companySettingsUrl &&
            <Button
              variant="info"
              bsSize="xsmall"
              href={companySettingsUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              storEDGE Hyper
            </Button>
          }
        </ButtonToolbar>
      </td>
    </tr>
  );
}

const Table = ({ sites }) => (
  <BootstrapTable>
    <thead>
      <tr>
        <th>Website</th>
        <th>Date Added</th>
        <th />
      </tr>
    </thead>
    <tbody>
      {sites.map(renderRow)}
    </tbody>
  </BootstrapTable>
);
Table.propTypes = {
  sites: PropTypes.arrayOf(PropTypes.shape({
    companyId: PropTypes.string.isRequired,
    identifier: PropTypes.string.isRequired,
    internalUrl: PropTypes.string.isRequired,
    dateAdded: PropTypes.string.isRequired,
    company: PropTypes.shape({
      name: PropTypes.string.isRequired,
      storEdgeUrl: PropTypes.string.isRequired,
      corporateUrl: PropTypes.string.isRequired,
    }).isRequired,
  })).isRequired,
};

export default Table;
